import { TransversalPageProps } from './[transversal]';
import React, { ComponentPropsWithRef, FC } from 'react';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import InsuranceIframe from '@components/InsuranceIframe/InsuranceIframe.component';
import { Text } from '@components/Text/Text.component';
import { PlcPageHeader } from '@layout/components/PlcPageHeader/PlcPageHeader.component';
import { PlcPageLayout } from '@layout/components/PlcPageLayout/PlcPageLayout.component';
import { defaultNamespaces } from '@utils/strings';
import classnames from 'classnames';
import { PlcNextPageContext } from 'features/business/app.types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export type TransversalLayoutProps = ComponentPropsWithRef<'main'> & TransversalPageProps;

interface Props {
  data: string;
}

const EspaceInsurance: FC<TransversalLayoutProps & Props> = ({ className, data, ...rest }) => {
  const rootClass = classnames('plc-page', 'espaceAssurance', className);
  const pageTitle = `common.transversal.espaceAssurance.title`;

  return (
    <PlcPageLayout className={rootClass} metaTitleI18n={pageTitle} {...rest}>
      <PlcPageHeader heroImgSrc="inscription" i18nTitle={pageTitle} withBlockAd={false} />
      <section className="wrapper-s main-section">
        <InsuranceIframe />
        <Text className="none-up-m" variant="small">
          L'espace Assurances Prairies n'est pas optimisé pour le mobile.{' '}
          <BasicLink
            href={
              process.env.NEXT_STATIC_INSURANCE_URL ||
              'https://pacifica-production.agreo.fr/ASPNET/specific/pacifica/?pleinchamp=1&wscheck=0'
            }
            isUnderlined
            target="_blank"
          >
            Veuillez cliquer ici
          </BasicLink>{' '}
          pour accéder à l'espace optimisé pour un ordinateur
        </Text>
      </section>
    </PlcPageLayout>
  );
};

export async function getStaticProps({ locale }: PlcNextPageContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'fr', defaultNamespaces)),
    },
  };
}

export default EspaceInsurance;
